<template>
  <div class="approval-list-wrap">
    <v-list
      v-for="applItem in GET_APPL_USER_LIST"
      :key="applItem.agreeSeq"
      class="approval-item"
    >
      <div>
        <v-list-item class="pl-0 pr-5">
          <!-- 결재구분 -->
          <v-list-item-icon class="align-self-center">
            <v-chip
              label
              v-text="
                applItem.applTypeCd == 10 && applItem.deputyYn != 'Y'
                  ? '결재'
                  : applItem.applTypeCdNm
              "
              class="step"
              :class="stepChipClass(applItem.applTypeCd)"
            ></v-chip>
          </v-list-item-icon>

          <!-- 결재자 정보 -->
          <v-list-item-content>
            <v-list-item-title
              class="name"
              v-text="applItem.agreeEmpAlias"
            ></v-list-item-title>
            <v-list-item-subtitle
              ><span v-text="applItem.jikwee" class="position"></span
              ><span v-text="applItem.org" class="divider position"></span>
            </v-list-item-subtitle>
            <v-list-item-subtitle
              v-text="
                applItem.deputyYn == 'Y' && applItem.applTypeCdNm != '대결'
                  ? ''
                  : applItem.ymd
              "
              class="app-date"
            ></v-list-item-subtitle>
          </v-list-item-content>

          <!-- 결재상태 -->
          <!-- 대결이아닐때 -->
          <v-list-item-icon v-if="applItem.deputyYn != 'Y'">
            <v-chip
              v-if="GET_APPL_SEQ_EXIST == 'Y' && applItem.agreeStatusCd != null"
              class="status"
              :class="statusChipClass(applItem.agreeStatusCd)"
            >
              {{ applItem.agreeStatusCdNm }}

              <v-icon size="16">
                {{
                  applItem.applTypeCd == 30
                    ? 'mdi-note-text'
                    : applItem.agreeStatusCd == 30
                    ? 'mdi-close'
                    : applItem.agreeStatusCd == 20
                    ? 'mdi-check'
                    : ''
                }}
              </v-icon>
            </v-chip>
          </v-list-item-icon>
          <!-- 대결인데 결재가아닐때 (결재자랑 대결자랑 같을때) -->
          <v-list-item-icon
            v-if="
              applItem.deputyYn == 'Y' &&
              applItem.deputySabun == applItem.agreeSabun
            "
          >
            <v-chip
              v-if="GET_APPL_SEQ_EXIST == 'Y' && applItem.agreeStatusCd != null"
              class="status"
              :class="statusChipClass(applItem.agreeStatusCd)"
            >
              {{ applItem.agreeStatusCdNm }}

              <v-icon size="16">
                {{
                  applItem.applTypeCd == 30
                    ? 'mdi-note-text'
                    : applItem.agreeStatusCd == 30
                    ? 'mdi-close'
                    : applItem.agreeStatusCd == 20
                    ? 'mdi-check'
                    : ''
                }}
              </v-icon>
            </v-chip>
          </v-list-item-icon>
        </v-list-item>

        <!-- (결재단계) 결재의견 : 2024.04.21 결재의견(반려) 모바일에서 확인 가능하게 대결자에 대한 체크 부분 제거 applItem.deputyYn == 'Y' && applItem.deputySabun == applItem.agreeSabun-->
        <v-list-item
          v-if="
            GET_APPL_SEQ_EXIST == 'Y' &&
            applItem.memo != null &&
            applItem.memo != ''
          "
          class="opinion-outer"
        >
          <!-- <v-list-item-action></v-list-item-action> -->
          <v-list-item-content class="pt-0 pb-5 pr-5">
            <v-sheet class="opinion-wrap" color="lightGrey">
              <v-list-item-subtitle class="opinion-title"
                >의견</v-list-item-subtitle
              >
              <div class="opinion-desc">{{ applItem.memo }}</div>
            </v-sheet>
          </v-list-item-content>
        </v-list-item>
        <v-divider inset></v-divider>
      </div>
    </v-list>
  </div>
</template>

<script>
/* 결재자 리스트 */
import { mapGetters } from 'vuex';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_APPL_USER_LIST', 'GET_APPL_SEQ_EXIST']),
    stepChipClass() {
      return applTypeCd => {
        return {
          // 결재구분코드(30:기안, 10:결재)
          draft: applTypeCd == 30,
          approval: applTypeCd == 10,
        };
      };
    },
    statusChipClass() {
      return agreeStatusCd => {
        return {
          // 결재상태코드(10:결재요청, 20:결재완료, 30:반려)
          accept: agreeStatusCd == 20,
          reject: agreeStatusCd == 30,
        };
      };
    },
  },
};
</script>

<style></style>
